import { WagmiProvider, createConfig, http } from 'wagmi'

import { arbitrum, mainnet } from 'wagmi/chains'
import { walletConnect, injected, coinbaseWallet } from 'wagmi/connectors'
export const config = createConfig({
  chains: [mainnet, arbitrum],
  connectors: [
    injected(),
    walletConnect({
      projectId: '14808831369ecdaaab7b8869eb13c6b0',
      metadata: {
        name: 'Risk Market',
        description: 'Real-Time Decision-Based Trading',
      },
    }),
    coinbaseWallet({
      appName: 'Risk Market',
    }),
  ],
  transports: {
    [arbitrum.id]: http(),
    [mainnet.id]: http(),
  },
})
